import React, { useCallback, useEffect, useState } from "react";
import "./AboutPage.css";
import { Row } from "react-bootstrap";
import { STOREDELIVERY_CHARGES } from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { ValidateTime, formatPhoneNumber } from "../../comman/components/TimeSence";
import { formatPhoneNumberturkish } from "../../comman/components/TimeSence";
import ImageViewer from "react-simple-image-viewer";

function AboutPage(props) {
  const { t } = useTranslation();
  let storeId = window.location.pathname.split("/").pop();
  const [rangelist, setRangelist] = useState([]);

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  // eslint-disable-next-line
  useEffect(() => {
    if (props.detailTab === "about") {
      (async () => openSelectdelivery())();
    }
    // eslint-disable-next-line
  }, [props.detailTab]);

  const openSelectdelivery = async () => {
    let responce = await getRequestcall(
      STOREDELIVERY_CHARGES + `/${storeId}`,
      props?.access_token
    );
    if (responce?.status === 200) {
      const resultStoreCharges = await responce?.json();
      let getList = resultStoreCharges?.data?.charges;
      setRangelist(getList);
    }
  };


  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const isValidHttpUrl = (string) => {
    try {
      const url = new URL(string);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (err) {
      return false;
    }
  }
  return (
    <div className="about">
      <Row>
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          {rangelist.length !== 0 && (
            <>
              <h5 className="ms-2">
                {t("pages.Minmum order amount and delivery charges")}
              </h5>
              <div className="table-responsive">
                <table className="table table-borderless rangelist">
                  <thead>
                    <tr>
                      <th>{t("pages.Min price")}</th>
                      <th>{t("pages.Max price")}</th>
                      <th>{t("pages.Delivery charges")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rangelist.map((item) => (
                      <tr>
                        <td>{item?.min_price}</td>
                        <td>{item?.max_price}</td>
                        <td>{item?.delivery_charge}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div className="table-responsive">
            <table className="table table-borderless store-about">
              <tbody>
                {props?.storedetail.working_hours_from === null ||
                  props?.storedetail.working_hours_to === null ? (
                  <tr>
                    <td style={{width:"15%"}}>{t("pages.Working Hours")}</td>
                    <td className="value-column">
                      <ValidateTime time={"00:00 am"} /> {t("pages.storedetail.about.to")} <ValidateTime time={"00:00 pm"} />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td style={{width:"15%"}}>{t("pages.Working Hours")}</td>
                    <td className="value-column">
                      <ValidateTime time={props?.storedetail?.working_hours_from} /> - <ValidateTime time={props?.storedetail?.working_hours_to} />
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{width:"15%"}}>{t("pages.Delivery Time")}</td>
                  <td className="value-column">
                    {props?.storedetail.delivery_max_time}
                  </td>
                </tr>
                <tr>
                  <td style={{width:"15%"}}>
                    {props?.storedetail?.type === "goods"
                      ? t("pages.Categories")
                      : t("pages.Services")}
                  </td>
                  <td className="value-column">
                    {
                      props?.language === "Tr" ?
                        props?.storedetail?.service_title_in_tr !== "" ? props?.storedetail?.service_title_in_tr?.replaceAll(',', ', ') : props?.storedetail?.service_title?.replaceAll(',', ', ')
                        :
                        props?.storedetail?.service_title?.replaceAll(',', ', ')
                    }
                  </td>
                </tr>
                <tr>
                  <td style={{width:"15%"}}>{t("pages.storedetail.about.contact")}</td>
                  <td className="value-column">
                    <a
                      href={`tel:${props?.storedetail?.country_code}${props?.storedetail?.contact
                        }`}
                    >
                      {props?.storedetail?.country_code === "+91"
                        ? props?.storedetail?.country_code +
                        " " +
                        formatPhoneNumber(props?.storedetail?.contact)
                        : props?.storedetail?.country_code +
                        " " +
                        formatPhoneNumberturkish(props?.storedetail?.contact)}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td style={{width:"15%"}}>{t("pages.storedetail.about.email")}</td>
                  <td className="value-column">
                    {
                      props?.storedetail?.email !== "girne@appristine.in" && (
                        <a
                          href={`mailto: ${props?.storedetail?.email
                            }`}>{props?.storedetail?.email}</a>
                      )
                    }
                  </td>
                </tr>
                <tr>
                  <td style={{width:"15%"}}>{t("pages.storedetail.about.weburl")}</td>
                  <td className="value-column">
                    {
                      // eslint-disable-next-line react/jsx-no-target-blank
                      <a
                        target={"_blank"}
                        href={isValidHttpUrl(props?.storedetail?.website_url) ? `${props?.storedetail?.website_url}` : `${"https://" + props?.storedetail?.website_url}`}
                      >
                        {props?.storedetail?.website_url}
                      </a>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-11 col-xl-12 description">
          <div>
            <h5>{t("pages.storedetail.about.description")}</h5>
            <p>{props?.storedetail?.description}</p>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-11 col-xl-12 description">
          <h5>{t("pages.Photos")}</h5>
          <ul>
            {props?.storedetail?.images?.map((item, index) => (
              <li>
                <img
                  src={item}
                  alt="view"
                  onClick={() => openImageViewer(index)}
                ></img>
              </li>
            ))}
          </ul>
        </div>
        {isViewerOpen && (
          <ImageViewer
            src={props?.storedetail?.images}
            currentIndex={currentImage}
            onClose={closeImageViewer}
            disableScroll={false}
            backgroundStyle={{
              backgroundColor: "rgba(0,0,0,0.9)"
            }}
            closeOnClickOutside={true}>

          </ImageViewer>
        )}
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps)(AboutPage);
